module.exports = __webpack_public_path__ + "img/lock-alt.dfe96d86.svg";